import { Button, ButtonsWrapper, Panel, Separator, Text } from "@nju/ui";

interface IConfirmDisagreementProps {
  backToProfile: () => void;
  confirmDisagreement: () => void;
  isLoading: boolean;
}

export function ConfirmDisagreement({
  backToProfile,
  confirmDisagreement,
  isLoading,
}: IConfirmDisagreementProps) {
  return (
    <Panel>
      <Text
        display="block"
        size={{
          "@onlyMobile": "l",
          "@fromTablet": "keyM",
        }}
        weight="bold"
      >
        rezygnujesz z kontaktu na swój numer telefonu?
      </Text>
      <Separator size="xxs" tone="invisible" />
      <Text
        display="block"
        size={{
          "@onlyMobile": "s",
          "@fromTablet": "l",
        }}
      >
        Czy na pewno <strong>nie chcesz</strong> otrzymywać informacji
        przypominających o płatnościach oraz kontaktu ze strony nju mobile w
        sprawie ewentualnych problemów technicznych?
      </Text>
      <Separator size="xxs" tone="invisible" />
      <ButtonsWrapper withSeparator={false}>
        <Button
          onPress={backToProfile}
          size={{ "@onlyMobile": "s" }}
          variant="secondary"
        >
          anuluj
        </Button>
        <Button
          isLoading={isLoading}
          onPress={confirmDisagreement}
          size={{ "@onlyMobile": "s" }}
        >
          tak, potwierdzam
        </Button>
      </ButtonsWrapper>
    </Panel>
  );
}
